<template>
    <AuthenticatedLayout>
        <div class="mb-4">
            <PairsHorisontalMenu
                currentPairSymbol="ALL"
                :pairsData="pairsData"
                :menuPairs="menuPairs"
                url="dashboard"
            />
        </div>

        <div class="mb-4">
            <Card>
                <template #content>
                    <div class="flex flex-row">
                        <div class="flex-auto border-500 border-right-1 p-2">
                            <div class="flex flex-column">
                                <div class="text-500 mb-2">Доступных средств</div>
                                <div class="text-900 text-2xl mb-2">${{availableUsd}}</div>
                                <div>
                                    <Link href="/settings" class="text-blue-500">Изменить</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>

        <div class="flex">
            <div class="flex-1">
                <Card>
                    <template #title>
                        Сделки по всем парам
                    </template>
                    <template #content>
                        <div v-if="deals.length > 0">
                            <DataTable :value="deals" selectionMode="single" dataKey="token">
                                <Column header="Монета" >
                                    <template #body="slotProps">
                                        <Link :href="'/dashboard/'+slotProps.data.pair.symbol" class="text-blue-500">{{slotProps.data.pair.base_asset}}</Link>
                                    </template>
                                </Column>
                                <Column header="" field="token" ></Column>
                                <Column header="Покупка (GMT+3)" >
                                    <template #body="slotProps">
                                        {{short_timezoned(slotProps.data.started_at)}}
                                    </template>
                                </Column>
                                <Column header="Причина" field="start_reason" ></Column>
                                <Column header="Курс" field="rate_started" ></Column>
                                <Column header="Продано (GMT+3)" >
                                    <template #body="slotProps">
                                        <span v-if="slotProps.data.completed_at">{{short_timezoned(slotProps.data.completed_at)}}</span>
                                    </template>
                                </Column>
                                <Column header="Длительность" field="open_minutes" ></Column>
                                <Column header="Причина" field="complete_reason" ></Column>
                                <Column header="%" field="percent_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.percent_profit">
                                            <div v-if="slotProps.data.percent_profit < 1" v-html="round_red(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                            <div v-else v-html="round_green(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                                        </div>
                                    </template>
                                </Column>
                                <Column header="Профит" field="value_profit" >
                                    <template #body="slotProps">
                                        <div v-if="slotProps.data.value_profit">
                                            <div v-html="round_colored(slotProps.data.value_profit, 4)"></div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div v-else>
                            <p>Отсутствуют.</p>
                        </div>
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Все логи
                    </template>
                    <template #content>
                        <div v-if="logs.length > 0">
                            <DataTable :value="logs" selectionMode="single" dataKey="id">
                                <Column header="">
                                    <template #body="slotProps">
                                        <Link :href="'/dashboard/'+slotProps.data.pair.symbol" class="text-blue-500">{{slotProps.data.pair.base_asset}}</Link>
                                    </template>
                                </Column>
                                <Column header="Дата" >
                                    <template #body="slotProps">
                                        {{short_timezoned(slotProps.data.date)}}
                                    </template>
                                </Column>
                                <Column header="" field="level" ></Column>
                                <Column header="Сообщение" >
                                    <template #body="slotProps">
                                        <span>{{slotProps.data.message}}</span>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div v-else>
                            <p>Логи отсутствуют.</p>
                        </div>
                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";

export default {
    props: {
        deals: Array,
        logs: Array,
        availableUsd: String,
        pairsData: Array,
        menuPairs: String
    },
    components:{
        PairsHorisontalMenu,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link
    },
    data(){
        return {

        }
    },
    methods:{
        ...helperMethods,
    }
}
</script>

